module.exports = __webpack_public_path__ + "img/reports.69939254.png";